// 简单的通知插件
const notify = {
  install(Vue) {
    Vue.prototype.$notify = function(options) {
      const notification = document.createElement('div')
      notification.className = `notification ${options.type || 'info'}`
      notification.textContent = options.message
      
      document.body.appendChild(notification)
      
      setTimeout(() => {
        notification.remove()
      }, 3000)
    }
  }
}

export default notify